export const LOGO_MARK =
  "https://static.prod-images.emergentagent.com/jobs/d3dc4424-79cc-407c-9bb5-e6f0a32f7a17/images/8dbc590443add6fe828a114aa5ff572131448dce48461cb09c00f2ebbf76279b.png";
export const LOGO_FULL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_safer-landing/artifacts/8ep2ux17_Safe%28H%29er%20Premium%20App%20Logo%20Concepts.png";
export const LOGO_DARK = LOGO_MARK;
export const LOGO_LIGHT = LOGO_MARK;

export const IMAGES = {
  heroPortrait:
    "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjb25maWRlbnQlMjB3b21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NDUwMzk2N3ww&ixlib=rb-4.1.0&q=85",
  community:
    "https://images.pexels.com/photos/32268262/pexels-photo-32268262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  app:
    "https://images.pexels.com/photos/11989314/pexels-photo-11989314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  texture:
    "https://images.pexels.com/photos/5218431/pexels-photo-5218431.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SOCIALS = {
  instagram: "https://www.instagram.com/safherofficial/",
  x: "https://x.com/safeherapp",
};

export const EMERGENT_VOTE =
  "https://app.emergent.sh/showcase/fabrizio/e26cc008-434e-415c-97a2-71b41927a26c?utm_source=share";

export const PRIVACY_POLICY =
  "https://github.com/safherofficial/policy/blob/main/PRIVACY_POLICY.md";

export const NAV = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Funzioni", href: "#funzioni" },
  { label: "L'app", href: "#app" },
  { label: "Community", href: "#social" },
];
